import React, { useState, useContext, useRef, forwardRef, useEffect, useCallback } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InputAdornment from '@mui/material/InputAdornment';
import { ReactComponent as ArrowDown } from "../../assets/images/ralvie/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "../../assets/images/ralvie/ArrowUp.svg";
import { ReactComponent as ClearIconDark } from "../../assets/images/ralvie/clearTextIconDark.svg";
import AppContext from "../../config/AppContext";
import { ReactComponent as SearchIcon } from "../../assets/images/ralvie/SearchIcon.svg";
import CustomDeleteButton from "../../components/CustomDeleteButton";
import CloseIcon from '@mui/icons-material/Close';


import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Chip,
  Autocomplete,
  IconButton,
  Tooltip,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  Checkbox,
  OutlinedInput,
  ListItem,
  Avatar,
  List,
  Typography,
  Grid,
  Box
} from '@mui/material';

import "./AddMemberlist.scss";
import "./AddProject.scss";
import CustomButton from "../../components/CustomButton";
import { useTranslation } from "react-i18next";
import { userList } from '../../services/MemberService';
import { toast } from 'sonner';
import { designationList } from '../../services/DesignationService';
import { departmentList } from '../../services/DepartmentService';
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
import { ReactComponent as EmptyMemberListDark } from "../../assets/images/ralvie/empty-member-list-dark.svg";
import { ReactComponent as EmptyMemberList } from "../../assets/images/ralvie/empty-member-list.svg";

const AddMembersComponent = forwardRef(({ EditData = [], isEditForm, billableCostData,setUserList = ()=>{}, ...props }, ref) => {

  const { expanded, onChange, ...otherProps } = props;
  const [searchNameOrEmail, setSearchNameOrEmail] = useState("");
  const dropdownRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [cost, setCost] = useState(billableCostData || "");
  const [billableAmount, setBillableAmount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMembers, setSelectedMembers] = useState([]);
  const selectedMembersRef = useRef(selectedMembers);
  const [actualMembers, setActualMembers] = useState([]);
  const wrapperRef = useRef(null);
  const [members, setMembers] = useState([]);
  const [allMembers, setAllMembers] = useState([]);
  const [showFilterError, setShowFilterError] = useState(false);
  const [filter, setFilter] = useState({
    status: "",
    name: "",
    email: "",
    toggleKeyToURL: true,
    includeArchived: true,
    department: [],
    designation: [],
  });
  const [memberFilter, setMemberFilter] = useState("");
  const inputRef = useRef(null);
  const [approver, setApprover] = useState("");
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const { mode } = useContext(AppContext);

  useEffect(() => {
    if (allMembers?.length > 0 && cost === "Member default") {
      setSelectedMembers((prevSelectedMembers) => {
        let updatedList = prevSelectedMembers.map((member) => {
          const memberData = members.find((m) => m.id === member?.id);
          if (!memberData) {
            console.error(`No member data found for member ID ${member?.id}`);
            return member;
          }
          return {
            ...member,
            cost: memberData.costPerHour,
          };
        });

        selectedMembersRef.current = updatedList;
        return updatedList;
      });

      setActualMembers((prevSelectedMembers) => {
        let updatedList = prevSelectedMembers.map((member) => {
          const memberData = members.find((m) => m.id === member?.id);
          if (!memberData) {
            console.error(`No member data found for member ID ${member?.id}`);
            return member;
          }
          return {
            ...member,
            cost: memberData.costPerHour,
          };
        });

        return updatedList;
      });
    }
  }, [allMembers]);

  useEffect(() => {
    setCost(billableCostData);
  }, [billableCostData]);

  useEffect(() => {
    if (EditData && EditData?.length > 0) {
      setSelectedMembers(actualMembers);
    }
  }, [open]);

  useEffect(() => {
    if (EditData && EditData?.length > 0) {
      setSelectedMembers(EditData);
      setActualMembers(EditData);
      selectedMembersRef.current = EditData;
      setBillableAmount(
        billableCostData === "Common cost" ? EditData[0]?.cost || 0 : 0
      );
    }
  }, [EditData, billableCostData]);

  const loadMembers = async () => {
    setLoading(true);
    try {
      const res = await userList({
        ...filter,
        includeArchived: false
      });
      if (res?.status === 200 && res?.data?.code === "UASI0000") {
        const notClient = res?.data?.data?.users.filter(
          (user) => user?.roleName !== "Client"
        );
        const sortedNotClient = notClient?.sort((a, b) =>
          a.memberName?.localeCompare(b?.memberName)
        );
        setUserList(sortedNotClient);
        setAllMembers(sortedNotClient);
      } else {
        setAllMembers([]);
        setUserList([]);
      }
    } catch (error) {
      console.error("Error loading members:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMembers();
  }, [])

  useEffect(() => {
    const loadFilterMembers = async () => {
      setLoading(true);
      try {
        const res = await userList(filter);
        if (res?.status === 200 && res?.data?.code === "UASI0000") {

          const filteredMembers = res?.data?.data?.users.filter(
            (user) => user?.roleName !== "Client" && user?.status !== "ARCHIVED"
          );

          const sortedFilteredMembers = filteredMembers?.sort((a, b) =>
            a?.memberName?.localeCompare(b.memberName)
          );
          setMembers(sortedFilteredMembers || []);

        } else {
          setMembers([]);
        }
      } catch (error) {
        console.error("Error loading members:", error);
      } finally {
        setLoading(false);
      }
    };
    loadFilterMembers();
  }, [filter]);

  const handleToggle = useCallback(
    (member) => {
      const storedUser = JSON.parse(localStorage.getItem("USER"));
      if (storedUser && member?.id === storedUser.id) {
        return;
      }
      setSelectedMembers((prevSelectedMembers) => {
        const isSelected = prevSelectedMembers.some(
          (selectedMember) => selectedMember?.id === member?.id
        );
        if (isSelected) {
          let updatedList = prevSelectedMembers.filter(
            (selectedMember) => selectedMember?.id !== member?.id
          );
          selectedMembersRef.current = updatedList;
          return updatedList;
        } else {
          let memberCost =
            cost === "Member default" ? member?.costPerHour : billableAmount;
          let updatedList = [
            ...prevSelectedMembers,
            { ...member, cost: memberCost },
          ];
          selectedMembersRef.current = updatedList;
          return updatedList;
        }
      });
    },
    [billableAmount, cost]
  );

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("USER"));
    if (storedUser && storedUser.id && !isEditForm) {
      setSelectedMembers((prevSelectedMembers) => {
        if (
          !prevSelectedMembers.some((member) => member?.id === storedUser.id)
        ) {
          let updatedList = [
            ...prevSelectedMembers,
            {
              id: storedUser.id,
              cost:
                billableCostData === "Member default"
                  ? storedUser.costPerHour
                  : billableAmount,
            },
          ];
          selectedMembersRef.current = updatedList;
          return updatedList;
        }

        selectedMembersRef.current = prevSelectedMembers;
        return prevSelectedMembers;
      });

      setActualMembers((prevSelectedMembers) => {
        if (
          !prevSelectedMembers.some((member) => member?.id === storedUser.id)
        ) {
          let updatedList = [
            ...prevSelectedMembers,
            {
              id: storedUser.id,
              cost:
                billableCostData === "Member default"
                  ? storedUser.costPerHour
                  : billableAmount,
            },
          ];
          selectedMembersRef.current = updatedList;
          return updatedList;
        }

        selectedMembersRef.current = prevSelectedMembers;
        return prevSelectedMembers;
      });
    }
  }, [billableCostData, billableAmount]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchNameOrEmail(value);
  };

  const clearFilterName = () => {
    setSearchNameOrEmail("");
  };

  const handleMemberSearch = (event) => {
    setMemberFilter(event.target.value);
  };
  const handleClear = () => {
    setMemberFilter("");
    inputRef.current?.blur();
    setTimeout(() => inputRef.current?.focus(), 0);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };
  const handleClearClient = () => {
    // const storedUser = JSON.parse(localStorage.getItem("USER"));
    // if (storedUser && storedUser.id) {
    //   const userFromMembers = members.find(
    //     (member) => member?.id === storedUser.id
    //   );
    //   const userCost = userFromMembers
    //     ? userFromMembers.costPerHour
    //     : billableAmount;

    //   setSelectedMembers([{ id: storedUser.id, cost: userCost }]);
    // } else {
      setSelectedMembers([]);
    // }
  };

  const handleSelectMembers = () => {
    if (selectedMembers?.length <= 0) {
      toast.error(t("RAL0303"));
    } else {
      props.selectedEmployee(selectedMembers);
      // setSelectedMembers(selectedMembers);
      setActualMembers(selectedMembers);
      setOpen((prevState) => !prevState);
    }
  };

  const handleClick = useCallback(() => {
    clearFilterName();
    setOpen((prevState) => !prevState);
  }, [open]);

  const handleClose = () => {
    const storedUser = JSON.parse(localStorage.getItem("USER"));
    if (storedUser && storedUser.id && !isEditForm) {
      // Attempt to find the user's cost from the members list
      setSelectedMembers(actualMembers);
    } else {
      setSelectedMembers([]);
    }
    clearFilterName();
    setOpen((prevState) => !prevState);
  };

  const handleRemove = (memberId) => {
    // const storedUser = JSON.parse(localStorage.getItem("USER"));
    // if (storedUser && memberId === storedUser.id) {
    //   return;
    // }
    const updatedSelectedMembers = selectedMembers.filter(
      (member) => member?.id !== memberId
    );
    setActualMembers(updatedSelectedMembers);
    setSelectedMembers(updatedSelectedMembers);
    selectedMembersRef.current = updatedSelectedMembers;
    props.selectedEmployee(updatedSelectedMembers);
  };

  const handleBillableCost = (e) => {
    const selectedCost = e.target.value;
    setCost(selectedCost);
    if (selectedCost === "Common cost") {
      setBillableAmount(0);
      setSelectedMembers((prevSelectedMembers) => {
        let updatedList = prevSelectedMembers.map((member) => ({
          ...member,
          cost: 0,
        }));
        selectedMembersRef.current = updatedList;
        return updatedList;
      });

      setActualMembers((prevSelectedMembers) => {
        let updatedList = prevSelectedMembers.map((member) => ({
          ...member,
          cost: 0,
        }));
        selectedMembersRef.current = updatedList;
        return updatedList;
      });
    } else if (selectedCost !== "Common cost") {
      setBillableAmount(0);
      if (selectedCost === "Individual cost") {
        setSelectedMembers((prevSelectedMembers) => {
          let updatedList = prevSelectedMembers.map((member) => ({
            ...member,
            cost: 0,
          }));
          selectedMembersRef.current = updatedList;
          return updatedList;
        });

        setActualMembers((prevSelectedMembers) => {
          let updatedList = prevSelectedMembers.map((member) => ({
            ...member,
            cost: 0,
          }));
          selectedMembersRef.current = updatedList;
          return updatedList;
        });
      }
      else if (selectedCost === "Member default") {
        setSelectedMembers((prevSelectedMembers) => {
          let updatedList = prevSelectedMembers.map((member) => {
            const memberData = members.find((m) => m.id === member?.id);
            if (!memberData) {
              console.error(`No member data found for member ID ${member?.id}`);
              return member;
            }
            return {
              ...member,
              cost: memberData.costPerHour,
            };
          });
          selectedMembersRef.current = updatedList;
          return updatedList;
        });

        setActualMembers((prevSelectedMembers) => {
          let updatedList = prevSelectedMembers.map((member) => {
            const memberData = members.find((m) => m.id === member?.id);
            if (!memberData) {
              console.error(`No member data found for member ID ${member?.id}`);
              return member;
            }
            return {
              ...member,
              cost: memberData.costPerHour,
            };
          });
          selectedMembersRef.current = updatedList;
          return updatedList;
        });
      }
    }
    props.billableType(selectedCost);
  };

  const handleBillableAmount = (e) => {
    let input = e.target.value;

    const inputValue = /^(\d{0,5})(\.\d{0,2})?$/;
    if (input === "" || inputValue.test(input)) {
      setBillableAmount(input);

      if (cost === "Common cost") {
        setSelectedMembers((prevSelectedMembers) => {
          let updatedList = prevSelectedMembers.map((member) => ({
            ...member,
            cost: input,
          }));
          selectedMembersRef.current = updatedList;
          return updatedList;
        });

        setActualMembers((prevSelectedMembers) => {
          let updatedList = prevSelectedMembers.map((member) => ({
            ...member,
            cost: input,
          }));
          selectedMembersRef.current = updatedList;
          return updatedList;
        });
      } else if (cost === "Individual cost") {
        setSelectedMembers((prevSelectedMembers) => {
          let updatedList = prevSelectedMembers.map((member) => ({
            ...member,
            cost: member?.cost === "Member default" ? member?.cost : input,
          }));
          selectedMembersRef.current = updatedList;
          return updatedList;
        });

        setActualMembers((prevSelectedMembers) => {
          let updatedList = prevSelectedMembers.map((member) => ({
            ...member,
            cost: member?.cost === "Member default" ? member?.cost : input,
          }));
          selectedMembersRef.current = updatedList;
          return updatedList;
        });
      }
    }
  };

  const handleIndividualCostChange = (memberId, value) => {
    value = value.replace(/[^0-9.]/g, "");
    if (value.length > 1 && value[0] === '0' && value[1] !== '.') {
      value = value.substring(1);
    }
    const inputValue = /^\d{0,5}(\.\d{0,2})?$/;
    if (value === "" || inputValue.test(value)) {
      const decimalIndex = value.indexOf(".");
      if (decimalIndex >= 0) {
        const decimalPart = value.substring(
          decimalIndex + 1,
          decimalIndex + 2 + 1
        );
        value = value.substring(0, decimalIndex + 1) + decimalPart;
      }

      if (value?.length > 20) {
        value = value.substring(0, 20);
      }

      setSelectedMembers((prevState) => {
        const updatedMembers = prevState.map((member) => {
          if (member?.id === memberId) {
            return { ...member, cost: value };
          }
          return member;
        });

        const newMember = { id: memberId, cost: value };
        const existingMember = updatedMembers.find(
          (member) => member?.id === memberId
        );

        if (!existingMember) {
          return [...updatedMembers, newMember];
        }
        selectedMembersRef.current = updatedMembers;
        return updatedMembers;
      });

      setActualMembers((prevState) => {
        const updatedMembers = prevState.map((member) => {
          if (member?.id === memberId) {
            return { ...member, cost: value };
          }
          return member;
        });

        const newMember = { id: memberId, cost: value };
        const existingMember = updatedMembers.find(
          (member) => member?.id === memberId
        );

        if (!existingMember) {
          return [...updatedMembers, newMember];
        }
        selectedMembersRef.current = updatedMembers;
        return updatedMembers;
      });
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      handleClose();
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);


  const handleMemberChange = (id) => () => {

    const newMember = members.find(m => m.id === id);

    if (!selectedMembers.includes(newMember)) {
      const storedUser = JSON.parse(localStorage.getItem("USER"));
      // if (storedUser && newMember?.id === storedUser.id) {
      //   return; // Prevent toggling the stored user
      // }
      // if (storedUser && !['OWNER', 'ADMIN', 'MANAGER'].includes(storedUser.roleCode)) {
      //    return;
      // }
      setSelectedMembers((prevSelectedMembers) => {
        const isSelected = prevSelectedMembers.some(
          (selectedMember) => selectedMember?.id === newMember?.id
        );
        if (isSelected) {
          let updatedList = prevSelectedMembers.filter(
            (selectedMember) => selectedMember?.id !== newMember?.id
          );
          selectedMembersRef.current = updatedList;
          return updatedList;
        } else {
          let memberCost =
            cost === "Member default" ? newMember?.costPerHour : billableAmount;
          let updatedList = [
            ...prevSelectedMembers,
            { ...newMember, cost: memberCost },
          ];
          selectedMembersRef.current = updatedList;
          return updatedList;
        }
      });
    }
  };

  const handleAllSelect = () => {
    // const storedUser = JSON.parse(localStorage.getItem("USER"));
    // const isStoredUserAllowed = storedUser && ['OWNER', 'ADMIN', 'MANAGER'].includes(storedUser.roleCode);

    const filteredMembers = members
       .filter(member => {
        const emailMatch = member?.email?.toLowerCase().includes(searchNameOrEmail?.toLowerCase() || "");
        const nameMatch = member?.memberName?.toLowerCase().includes(searchNameOrEmail?.toLowerCase() || "");
        return nameMatch || emailMatch;
      })
    //  .filter(member => isStoredUserAllowed);
  
    const allSelected = filteredMembers.every((em) =>
      selectedMembers.some((sm) => sm?.id === em?.id)
    );
  
    if (allSelected) {const updatedList = selectedMembers.filter(
        (m) => !filteredMembers.some((fm) => fm.id === m.id)
      );
      selectedMembersRef.current = updatedList;
      setSelectedMembers(updatedList);
    } else {
      const newFiltered = filteredMembers.filter(
        (fm) => !selectedMembers.some((sm) => sm.id === fm.id)
      );
  
      const mappedNewFiltered = newFiltered.map((item) => ({
        ...item,
        cost: cost === "Member default" ? item?.costPerHour : billableAmount,
      }));
  
      const updatedList = [...selectedMembers, ...mappedNewFiltered];
      selectedMembersRef.current = updatedList;
      setSelectedMembers(updatedList);
    }
  };
  
  const renderMembers = (department, memberList) => {
    const membersByDept = memberList
      .filter((m) => m.departmentName ? m.departmentName === department : !m.departmentName && department === "Others")
      .sort((a, b) => {
        const designationCompare = (a.designationName || '').localeCompare(b.designationName || '');
        if (designationCompare !== 0) return designationCompare;
        return a.memberName?.localeCompare(b.memberName);
      });

    return membersByDept.map((member) => (
      <div className={`memberRow-selected ${selectedMembers.some(
        (selectedMember) => selectedMember?.id === member?.id
      ) ? 'selected' : ''} ${mode === 'dark' ? 'dark' : ''}`}
        key={member.id}
      >
        <div>
          <Checkbox
            className="allcustomcheck11"
            checked={selectedMembers.some(
              (selectedMember) => selectedMember?.id === member?.id
            )}
            onChange={handleMemberChange(member.id)}
          />
          <span className="memberName">{member.memberName}</span>
        </div>
        <div>
          <span className="memberRole">{member.designationName}</span>
        </div>
      </div>
    ));
  };

  const [designations, setdesignations] = useState([]);
  const [selectedDesignations, setSelectedDesignationId] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);


  useEffect(() => {
    loadDesignations();
    loadData();
  }, []);

  const loadDesignations = () => {
    setdesignations([]);
    designationList({}).then((res) => {
      if (res?.data?.code === "RCI0000") {
        const sortedDesignations = [...res?.data?.data?.designations].sort((a, b) => 
        (a.name || "").localeCompare(b.name || "")
        );
        setdesignations(sortedDesignations);
      }
    });
  };

  const loadData = () => {
    const payload1 = {
      pageNumber: 1,
      pageSize: 1000,
    };
    departmentList(payload1).then((res) => {
      if (res.data.code === "RCI0000") {
        const sortedDepartments = [...res?.data?.data?.departments].sort((a, b) => 
        (a.name || "").localeCompare(b.name || "")
        );
        setDepartments(sortedDepartments);
      }
    });
  };

  useEffect(() => {
    props.selectedEmployee(actualMembers);
  }, [selectedMembers])

  const handleFilter = () => {
    if (selectedDesignations.length === 0 && selectedDepartments.length === 0) {
      setShowFilterError(true);
      return;
    }

    setShowFilterError(false);
    setFilter({
      ...filter,
      department: selectedDepartments.map(dept => dept.id),
      designation: selectedDesignations.map(desig => desig.id)
    });
  };

  return (
    <Accordion
      className="accordion"
      ref={ref}
      expanded={expanded}
      onChange={onChange}
      square={false}
      elevation={0}
      sx={{
        "&.MuiAccordion-root": {
          "::before": {
            content: "none",
          },
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <div className="accordion-text-column">
          <span className="labeladdbasic">{t("RAL0436")}</span>
          <span className={mode === "dark" ? "descriptionaddbasicDark" : "descriptionaddbasic"}>
            {t("RAL1035")}
          </span>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div className="project-tags-wrapper1">
          <label id="text-project-tags">
            {t("RAL1028")}
          </label>
          <div className="filternaivagate">
            <div className="roject-tags-wrapper11">
              <Autocomplete
                id="tags-outlined"
                className="tagSelect1"
                multiple
                options={designations || []}
                getOptionLabel={(option) => option.name}
                value={selectedDesignations}
                onChange={(e, newValue) => {
                  setSelectedDesignationId(newValue);
                  setShowFilterError(false);
                  if (newValue.length == 0) {
                    setFilter({
                      ...filter,
                      designation: []
                    });
                  }
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip label={option.name} {...getTagProps({ index })} />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder={t("RAL1029")} />
                )}
              />
              {showFilterError && (
                <div className="filter-error-message">
                  <ErrorIcon />
                  <span >{t("RAL1038")}</span>
                </div>
              )}
            </div>

            <div className="roject-tags-wrapper11">
              <Autocomplete
                id="tags-outlined"
                className="tagSelect1"
                multiple
                options={departments || []}
                getOptionLabel={(option) => option.name}
                value={selectedDepartments}
                onChange={(e, newValue) => {
                  setSelectedDepartments(newValue);
                  setShowFilterError(false);
                  if (newValue.length == 0) {
                    setFilter({
                      ...filter,
                      department: []
                    });
                  }
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip label={option.name} {...getTagProps({ index })} />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder={t("RAL1030")} />
                )}
              />
              {showFilterError && (
                <div className="filter-error-message">
                  <ErrorIcon />
                  <span>{t("RAL1038")}</span>
                </div>
              )}
            </div>
            <div>
              <CustomButton
                variant="contained"
                class="membersButton1234"
                id="btn-add-project"
                name="btn-add-project"
                onClick={handleFilter}
              >
                {t("RAL1031")}
              </CustomButton>
            </div>
            {(selectedDesignations.length > 0 || selectedDepartments.length > 0) && (
              <div>
                <CustomButton
                  variant="outlined"
                  class="membersButton1234"
                  id="btn-clear-filters"
                  name="btn-clear-filters"
                  onClick={() => {
                    setSelectedDesignationId([]);
                    setSelectedDepartments([]);
                    setFilter({ ...filter, department: [], designation: [] });
                    setShowFilterError(false);
                  }}
                >
                  {t("RAL0693")}
                </CustomButton>
              </div>
            )}

          </div>
        </div>

        <div className="add-members-block">
          <label> {t("RAL1032")}</label>
          <div className="search-member-wrapper" ref={wrapperRef}>
            <div className="projectSelectMem11">
              <TextField
                className="projectSelectMem"
                fullWidth
                id="text-search-member-project"
                name="text-search-member-project"
                placeholder={t("RAL0306")}
                value={searchTerm}
                onClick={handleClick}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end">
                        {open ? (
                          <ArrowUp id="project-arrowup-icon" />
                        ) : (
                          <ArrowDown id="project-arrowdown-icon" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            {open && (
              <div className="addMembers" ref={dropdownRef}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                  <TextField
                    fullWidth
                    id="text-search-member"
                    name="text-search-member"
                    placeholder={t("RAL0307")}
                    value={searchNameOrEmail}
                    className="projectSelectMem"
                    onChange={handleSearchChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            id="project-clear-icon"
                            aria-label="clear input"
                            onClick={clearFilterName}
                            sx={{
                              borderRadius: "5px",
                              background: "transparent",
                              visibility: searchNameOrEmail ? "inherit" : "hidden",
                              "& .clear_svg": {
                                transition: "color 0.3s ease",
                                color: mode === "dark" ? "var(--color-33-50)" : "#242424cc",
                              },
                              "&:hover": {
                                "& .hover-text, & .clear_svg": {
                                  color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                                },
                              },
                            }}
                          >
                            {searchNameOrEmail && (
                              <Tooltip title={t("RAL0693")}>
                                <ClearIconDark id="project-clear-icon" className="clear_svg" />
                              </Tooltip>
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                      inputProps: {
                        maxLength: 60,
                      },
                    }}
                  />
                </div>

                {(() => {
                  const filteredMembers = members.filter((member) => {
                    const emailMatch = member?.email?.toLowerCase().includes(searchNameOrEmail?.toLowerCase() || "");
                    const nameMatch = member?.memberName?.toLowerCase().includes(searchNameOrEmail?.toLowerCase() || "");
                    return nameMatch || emailMatch;
                  });

                  const filteredDepartments = Array.from(
                    new Set(filteredMembers.map(m => m.departmentName ? m.departmentName.trim() : "Others"))
                  ).sort((a, b) => {
                    if (a === "Others") return 1;
                    if (b === "Others") return -1;
                    return a?.localeCompare(b);
                  });

                  if (filteredMembers.length === 0) {
                    return (
                      <Grid
                        container
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          height: "290px",
                        }}
                      >
                        {mode == "light" ? (
                          <EmptyMemberList id="project-empty-icon" />
                        ) : (
                          <EmptyMemberListDark id="project-empty-icon" />
                        )}
                        <Typography id="project-empty-text" className="noMemberFound">
                          {t("RAL0321")}
                        </Typography>
                      </Grid>
                    );
                  }

                  return (
                    <>
                      <div className='selected123'>
                        <span className='selecetdmemnder'>{t("RAL0318")}</span>
                        <span className='selecetdmemnder11'>
                          {selectedMembers.filter(selectedMember =>
                            filteredMembers.some(member => member.id === selectedMember.id)
                          ).length} {t("RAL1033")}
                          <CloseIcon className="timeerrorduimension11" onClick={handleClearClient} /></span>
                      </div>

                      <div className={mode === "dark" ? "dividerbillingcarddark11" : "dividerbillingcard11"}></div>

                      <div className="allcustomcheck">
                        <Checkbox
                          className="allcustomcheck11"
                          checked={
                            filteredMembers.length > 0 &&
                            filteredMembers.every((m) =>
                              selectedMembers.some((s) => s.id === m.id)
                            )}
                          onChange={handleAllSelect}
                        />
                        <span>{t("RAL1034")}</span>
                      </div>

                      <div className="membername-email">
                        {filteredDepartments.map((dept, index) => (
                          <React.Fragment key={index}>
                            <div className="departmentTitle">{dept}</div>
                            {renderMembers(dept, filteredMembers)}
                            {index !== filteredDepartments.length - 1 && (
                              <div className={mode === 'dark' ? 'dividerbillingcarddark11' : 'dividerbillingcard11'}></div>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    </>
                  );
                })()}

                <div className="custombuttonstyle">
                  <CustomButton
                    place="sp-cancel"
                    variant="outlined"
                    class="memberSaveButton"
                    id="btn-cancel-member-list"
                    name="btn-cancel-member-list"
                    onClick={handleClose}
                    disabled={!members || members?.length === 0}
                  >
                    {t("RAL0177")}
                  </CustomButton>
                  <CustomButton
                    variant="contained"
                    class="memberCancelButton"
                    id="btn-save-member-list"
                    name="btn-save-member-list"
                    onClick={handleSelectMembers}
                    disabled={!members || members?.length === 0}
                  >
                    {t("RAL0309")}
                  </CustomButton>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className='Billable123'>
          <div>
            <label>{t("RAL0257")}</label>
          </div>
          <div>
            <FormControl className="billable-costaddmember">
              <RadioGroup
                id="btn-project-radiogroup"
                className="radio-group1092"
                value={cost}
                onChange={handleBillableCost}
              >
                <div className="radio-wrappermens">
                  <FormControlLabel
                    id="btn-radio-default-cost"
                    className="radio-optioniopu"
                    value="Member default"
                    control={<Radio className="custom-radio1" />}
                    label={t("RAL0311")}
                  />
                </div>
                <div className="radio-wrappermens">
                  <FormControlLabel
                    id="btn-radio-common-cost"
                    className="radio-optioniopu"
                    value="Common cost"
                    control={<Radio className="custom-radio1" />}
                    label={t("RAL0312")}
                  />
                </div>
                <div className="radio-wrappermens">
                  <FormControlLabel
                    id="btn-radio-individual-cost"
                    className="radio-optioniopu"
                    value="Individual cost"
                    control={<Radio className="custom-radio1" />}
                    label={t("RAL0313")}
                  />
                </div>
              </RadioGroup>
            </FormControl>
          </div>
          <div className='outlineedinputino'>
            <FormControl fullWidth variant="outlined">
              <OutlinedInput
                id="text-project-billableAmount"
                type="text"
                // inputProps={{ maxLength: 5 }}
                value={billableAmount}
                disabled={cost !== "Common cost"}
                onChange={handleBillableAmount}
                endAdornment={
                  <InputAdornment position="end">
                    {t("RAL0314")}
                  </InputAdornment>
                }
                className="outlineupdown"
              />
            </FormControl>
          </div>
        </div>
        <div className="membersList">
          <div className="MemberListInfo">
            <span
              id="text-project-memberlist"
              className="MemberHeader">
              {t("RAL0318")}
            </span>
            <TextField
              inputRef={inputRef}
              className="projectSelectMem"
              id="project-search-members-input"
              placeholder={t("RAL0223")}
              value={memberFilter}
              onKeyDown={handleKeyDown}
              onChange={handleMemberSearch}
              sx={{ width: "500px", }}
              inputProps={{ maxLength: 60 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" alignItems="center">
                    {memberFilter && (
                      <IconButton
                        id="project-clear-members-button"
                        aria-label="clear input"
                        onClick={handleClear}
                        onMouseDown={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        sx={{
                          borderRadius: "5px",
                          padding: "6px",
                          "& .clear_svg": {
                            transition: "color 0.3s ease",
                            color: mode === "dark" ? "var(--color-33-50)" : "#242424cc",
                          },
                          "&:hover": {
                            backgroundColor: "transparent",
                            "& .clear_svg": {
                              color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                            },
                          },
                        }}
                      >
                        <Tooltip
                          title={t("RAL0693")}
                          disableInteractive

                        >
                          <ClearIconDark className="clear_svg" />
                        </Tooltip>
                      </IconButton>
                    )}
                    <IconButton
                      id="project-search-members-button"
                      sx={{
                        borderRadius: "5px",
                        padding: "6px",
                        "& .search_svg": {
                          transition: "color 0.3s ease",
                          color: mode === "dark" ? "var(--color-33-50)" : "#242424cc",
                        },
                        "&:hover": {
                          backgroundColor: "transparent",
                          "& .search_svg": {
                            color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                          },
                        },
                      }}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      <Tooltip
                        title={t("RAL0180")}
                        disableInteractive
                        enterDelay={500}
                      >
                        <SearchIcon className="search_svg" />
                      </Tooltip>
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div >
            <div className="memberListName1">
              <div className='costmemberlistcomp1'>
                <span id="project-member-name">{t("RAL0239")} </span>
              </div>
              <div className='costmemberlistcomp'>
                <span id="project-member-cost" >
                  {t("RAL0320")}
                </span>
              </div>
            </div>
            <div className='memeberkistoutin' >
              {selectedMembers?.length > 0 &&
                allMembers
                  .filter(member => member.status !== "ARCHIVED")
                  .filter((member) =>
                    selectedMembers.some(
                      (selectedMember) => selectedMember?.id === member?.id
                    )
                  )
                  .filter((member) =>
                    member?.memberName
                      ?.toLowerCase()
                      ?.includes(memberFilter?.toLowerCase())
                  ).length > 0 ? (
                <Grid
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{
                    height: "100%",
                    maxHeight: "290px",
                  }}
                >
                  <List
                    id="project-member-list"
                    sx={{ overflowY: "auto", height: "90%", width: "100%" }}
                    className="memberListName"
                  >
                    {allMembers
                      .filter((member) =>
                        actualMembers?.some(
                          (selectedMember) =>
                            selectedMember?.id === member?.id
                        )
                      )
                      .filter((member) =>
                        member?.memberName
                          ?.toLowerCase()
                          ?.includes(memberFilter?.toLowerCase())
                      )
                      .sort((a, b) => {
                        const deptA = a.departmentName || "Others";
                        const deptB = b.departmentName || "Others";
                        const deptCompare = deptA.localeCompare(deptB);
                        if (deptCompare !== 0) return deptCompare;

                        const designationCompare = (a.designationName || '').localeCompare(b.designationName || '');
                        if (designationCompare !== 0) return designationCompare;

                        return a.memberName?.localeCompare(b.memberName);
                      })
                      .map((member) => (
                        <ListItem key={member?.id} >
                          <Grid
                            item
                            xs={5}
                            sm={5}
                            md={5}
                            lg={5}
                            display="flex"
                            alignItems="center"
                            gap={2}
                            width={"20%"}
                            marginLeft={"20px"}
                          >
                            <Avatar
                              id="project-member-avatar"
                              src={member?.profilePhoto}
                            />
                            <Tooltip
                              title={
                                member?.memberName?.length > 50
                                  ? member?.memberName
                                  : ""
                              }
                              placement="top"
                            >
                              <Typography
                                sx={{
                                  position: "relative",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  // maxWidth: "120px", // Adjust as needed
                                }}
                              >
                                <span>
                                  {member?.memberName?.length > 140
                                    ? `${member?.memberName.substring(
                                      0,
                                      140
                                    )}...`
                                    : member?.memberName}
                                </span>
                              </Typography>
                            </Tooltip>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            display="flex"
                            alignItems="center"
                            justifyContent={"flex-start"}
                            sx={{ marginLeft: "150px" }}
                          >
                            {cost === "Individual cost" &&
                              selectedMembersRef?.current ? (
                              <TextField
                                className="projectSelectMem"
                                id="project-member-add"
                                value={
                                  selectedMembersRef?.current?.find(
                                    (m) => m.id === member?.id
                                  )?.cost || "0"
                                }
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                    inputMode: 'decimal'
                                  },
                                  disabled: cost !== "Individual cost"
                                }}
                                type="text"
                                sx={{
                                  height: "40px",
                                  width: "90px",
                                }}
                                onChange={(e) =>
                                  handleIndividualCostChange(
                                    member?.id,
                                    e.target.value
                                  )
                                }
                                onBlur={(e) => {
                                  // Ensure empty values default to 0
                                  if (e.target.value === "") {
                                    handleIndividualCostChange(member?.id, "0");
                                  }
                                }}
                              />
                            ) : (
                              <Typography>
                                {
                                  actualMembers.find(
                                    (m) => m.id === member?.id
                                  )?.cost
                                }
                              </Typography>
                            )}
                            <Typography sx={{ marginLeft: "10px" }}>$/hr</Typography>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} lg={1}>
                            <CustomDeleteButton
                              id="project-member-delete"
                              onClick={() => handleRemove(member?.id)}
                            />
                          </Grid>
                        </ListItem>
                      ))}
                  </List>
                </Grid>
              ) : (
                <Grid
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    height: "290px",
                  }}
                >
                  {mode == "light" ? (
                    <EmptyMemberList id="project-empty-icon" />
                  ) : (
                    <EmptyMemberListDark id="project-empty-icon" />
                  )}
                  <Typography
                    id="project-empty-text"
                    className="noMemberFound"
                  >
                    {t("RAL0321")}
                  </Typography>
                </Grid>
              )}
            </div>
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
});
AddMembersComponent.displayName = 'AddMembersComponent';

export default AddMembersComponent;